var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.type != 1 ? _c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: function ($event) {
        return _vm.planFun({
          contractId: _vm.id
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))]) : _vm._e(), _vm.type == 1 ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("签约产品")))])]) : _vm._e(), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "paymentDeadlineName",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(_vm.replaceFn(text)) + " ")];
      }
    }, {
      key: "durationName",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(_vm.replaceFn(text)) + " ")];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.type != 1 ? _c("a-button", {
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.planFun(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.type == 1 ? _c("a-button", {
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.seeFun(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.palnShow ? _c("plan-model", {
    ref: "palnForm",
    on: {
      cancel: function ($event) {
        _vm.palnShow = false;
      },
      ok: _vm.getDataFun
    }
  }) : _vm._e(), _vm.palnSeeShow ? _c("plan-see-model", {
    ref: "palnSeeForm",
    on: {
      cancel: function ($event) {
        _vm.palnSeeShow = false;
      }
    }
  }) : _vm._e(), _vm.type != 1 ? _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("prev");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _vm.type != 1 ? _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("back");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("提交")))]) : _vm._e()], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };